import { render, staticRenderFns } from "./GerenciaResultadoBimestre.vue?vue&type=template&id=19c63b20"
import script from "./GerenciaResultadoBimestre.vue?vue&type=script&lang=js"
export * from "./GerenciaResultadoBimestre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports